import { HomeOrganizationLayout, HomeAnnouncementForm } from 'components';
import React from 'react';
/**
 * 組織機構公告表單頁
 */

export const HomeOrganizationAnnouncementFormPage = props => {
  return (<HomeOrganizationLayout>
    <HomeAnnouncementForm {...props} />
  </HomeOrganizationLayout>);
};
